<template>
  <div class="pg-dialog-table-package-tag">
    <span class="pg-dialog-table-package-tag-text" :class="[epcType]" v-if="tagText">{{
      tagText
    }}</span>
    <PgClickToRouterByBiz
      v-if="tagText !== '套包'"
      :value="value"
      :routerName="routerName"
      :routerQuery="routerQuery"
    />
    <PgSpan class="pg-dialog-table-package-tag-Btn" v-else @click="handleClick">{{ value }}</PgSpan>
    <PgDialogTablePackage
      v-if="tagText === '套包'"
      :visible.sync="visible"
      :url="tableData"
      v-bind="$attrs"
      sureText="关闭"
      cacelText=""
    />
  </div>
</template>
<script setup>
// 弹窗操作套包、定数包、定数盒、一物一码
import { PgClickToRouterByBiz, PgSpan } from '../../click-to-router/index'
import PgDialogTablePackage from './dialog-table-package.vue'
import { computed, ref } from 'vue'
import { numberAdd } from '../../../utils/index'
const props = defineProps({
  value: [String, Array, Object, Number],
  routerQuery: Object,
  routerName: String,
  // LOW_VALUE_PACKAGE / FIX_NUMBER_BOX / FIX_NUMBER_PACKAGE / UNIQUE_CODE
  epcType: String,
  url: [Array],
})

const tagText = computed(() => {
  if (props.epcType === 'LOW_VALUE_PACKAGE') {
    return '套包'
  } else if (props.epcType === 'FIX_NUMBER_BOX') {
    return '定数盒'
  } else if (props.epcType === 'FIX_NUMBER_PACKAGE') {
    return '定数包'
  } else if (props.epcType === 'UNIQUE_CODE') {
    return '一物一码'
  } else {
    return ''
  }
})

const tableData = computed(() => {
  if (tagText.value === '套包' && Array.isArray(props.url)) {
    const dataMap = new Map()
    props.url.forEach((item) => {
      if (dataMap.has(item.goodsInfo?.id)) {
        dataMap.get(item.goodsInfo?.id).push(item)
      } else {
        dataMap.set(item.goodsInfo?.id, [item])
      }
    })

    return Array.from(dataMap.values()).map((im) => {
      const totalAmount = im.reduce((total, item) => {
        return numberAdd(total, item.amount)
      }, 0)
      return {
        amount: totalAmount,
        ...im[0],
      }
    })
  }
  return []
})

const visible = ref(false)
const handleClick = () => {
  visible.value = true
}
</script>
<style lang="scss">
@import '../style/dialog-table-package-tag.scss';
</style>
